var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","fill":"none"}},_vm.$listeners),[_c('path',{attrs:{"stroke":"currentColor","stroke-width":"1.5","d":"M8 3v10m0 0L3 8m5 5 5-5"}})])
}
var staticRenderFns = []

export default { render: render }